// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
let limitWithoutBanners = +boostPFSConfig.custom?.products_per_page - (+boostPFSConfig.banner?.numberOfBannerPosition + +boostPFSConfig.banner?.numberOfImagePosition);

var boostPFSFilterConfig = {
	general: {
		limit: limitWithoutBanners,
		loadProductFirst: !1,
		numberFilterTree: 2,
		filterTreeMobileStyle: 'style3',
		separateRefineByFromFilter: true,
		paginationTypeAdvanced: true,
		activeLoadPreviousPage: true,
		enableKeepScrollbackPosition: 0
	}
};

(function () {
	var onSale = false,
		soldOut = false,
		priceVaries = false,
		images = [],
		boostPFSRangeWidths = [165, 360, 533, 720, 940, 1066],
		viewProduct = 0;

	if ( document.cookie.split('; ').find(row => row.startsWith('recently_viewed=')) ) {
		var recently_viewed = document.cookie
		.split('; ')
		.find(row => row.startsWith('recently_viewed='))
		.split('=')[1];
	} else {
		var recently_viewed = '';
	}

	const recently_viewed_ids = recently_viewed
		.split("%2C")
		.filter((id) => {
			return id;
		})
		.map((id) => +id);

	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		//console.log("data:", data)
		// Displaying price base on the policy of Shopify, have to multiple by 100
		soldOut = !data.available; // Check a product is out of stock
		onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Convert images to array
		images = data.images_info;
		// Get First Variant (selected_or_first_available_variant)
		firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}

		// const observer = new MutationObserver((mutations) => {
		// 	mutations.forEach((mutation) => {
		// 	if (mutation.addedNodes.length > 0) {
		// 		jQ('[data-product-card][data-product-handle="' + data.handle + '"]').each(function() {
		// 		if (onSale) {
		// 			jQ(this).find('.product-card__price').css('color', '#e94141');
		// 		}
		// 		});
		// 	}
		// 	});
		// });

		// observer.observe(document.body, {
		// 	childList: true,
		// 	subtree: true
		// });

		return data;
	}




	// Performance-optimized version with request queuing and batching
	const productGroupQueue = [];
	let isProcessingQueue = false;
	
	function compiteProductGroupCard(product, handle) {
		// Add to queue instead of immediate execution
		productGroupQueue.push({ product, handle });
		
		// Process queue with debouncing
		if (!isProcessingQueue) {
			isProcessingQueue = true;
			requestAnimationFrame(() => processProductGroupQueue());
		}
	}
	
	function processProductGroupQueue() {
		console.log('processProductGroupQueue', productGroupQueue)
		if (productGroupQueue.length === 0) {
			isProcessingQueue = false;
			return;
		}
		
		// Process in batches of 5 to avoid overwhelming the server
		const batch = productGroupQueue.splice(0, 5);
		const promises = batch.map(({ product, handle }) => 
			processProductGroup(product, handle)
		);
		
		Promise.all(promises).then(() => {
			// Continue processing remaining items
			if (productGroupQueue.length > 0) {
				requestAnimationFrame(() => processProductGroupQueue());
			} else {
				isProcessingQueue = false;
			}
		});
	}
	
	function processProductGroup(product, handle) {
		return new Promise((resolve) => {
			jQ.ajax({
				type: "GET", 
				url: `/products/${handle}?view=object-json`, 
				success: function (response) {
					const html = document.createElement("div");
					html.innerHTML = response;

					let groups = JSON.parse(html.querySelector("[data-json-products-group-response]").innerHTML);

					let images = buildImagesGroup(groups, product.id);
					let {colors, colorsCount} = buildColorsGroup(groups, product.id);
					let sizes = buildSizesGroup(groups, product.id, product);
					let json = buildJsonGroup(groups);
					let pictures = buildPicturesGroup(groups);

					// Render immediately with what we have
					let templateHTML = jQ('[data-product-card][data-product-handle="' + handle + '"]').html();
					templateHTML = templateHTML.replace(/<productimages><\/productimages>/g, images);
					templateHTML = templateHTML.replace(/<colorscount><\/colorscount>/g, colorsCount + ' ' + ((colorsCount > 1) ? boostPFSThemeConfig.label.count_colors : boostPFSThemeConfig.label.count_color));
					templateHTML = templateHTML.replace(/<colorslist><\/colorslist>/g, colors);
					templateHTML = templateHTML.replace(/<sizeslist><\/sizeslist>/g, sizes);
					
					// Update DOM immediately
					jQ('[data-product-card][data-product-handle="' + handle + '"]').html(templateHTML);
					jQ('[data-product-card][data-product-handle="' + handle + '"]')[0].querySelector('[data-product-json]').innerHTML = JSON.stringify(json);

					// Load pictures async (non-blocking)
					if (pictures) {
						jQ.ajax({
							type: "GET",
							url: `/?section_id=product-card-pictures&tag=${pictures}`,
							success: function (response) {
								const html = document.createElement("div");
								html.innerHTML = response;
								let picturesHtml = html.querySelector("#shopify-section-product-card-pictures").innerHTML;
								
								// Update pictures when loaded
								let card = jQ('[data-product-card][data-product-handle="' + handle + '"]');
								let currentHTML = card.html();
								currentHTML = currentHTML.replace(/<pictureslist><\/pictureslist>/g, picturesHtml);
								card.html(currentHTML);
							}
						});
					}

					/**
					 * Generating product cards one by one
					 */
					let templateProductCard = boostPFSTemplate.productGridItemHtml;
					let templateProducts = ``;

					// Reverse the products array so its sorted by Newest to Oldest created_at
					groups = groups.reverse();
					// Move products with compare at price (on sale) to the end of the product array
					groups = groups.sort((a,b) => (a.compare_at_price_min > b.compare_at_price_min) ? 1 : ((b.compare_at_price_min > a.compare_at_price_min) ? -1 : 0))

					groups.forEach((product) => {
						let thisProductId = product.id;
						let productNewCollection = product.tags.filter(item => item === "collection:New");
						let productNewToSale = product.tags.filter(item => item === "new-sale");
						product.price /= 100;
						product.price_max /= 100;
						product.price_min /= 100;
						product.compare_at_price_min /= 100;

						let itemHtml = templateProductCard;
						itemHtml = itemHtml.replace(/{{mobileProductWrapper}}/g, '');

						let sizes = buildSizesGroup([product], thisProductId, product);

						//console.log("sizes" , sizes);

						// Make this only replace the URL in <a> because if it replaces all product badges on desktop will break
    					itemHtml = itemHtml.replace('products/{{productHandle}}', 'products/' + product.handle);
						let compareAtPrice = buildCompareAtPrice(product);
						itemHtml = itemHtml.replace(/{{productCompareAtPrice}}/g, compareAtPrice.html);
						itemHtml = itemHtml.replace(/{{productOnSale}}/g, compareAtPrice.html)
						itemHtml = itemHtml.replace(/{{productCompareAtPriceHandle}}/g, compareAtPrice.hiddenClass);

						itemHtml = itemHtml.replace(/{{productTitle}}/g, buildColorName(product));
						itemHtml = itemHtml.replace(/{{productPrice}}/g, buildPrice(product));
						itemHtml = itemHtml.replace(/{{newLabel}}/g, boostPFSThemeConfig.label.badge_new);
						itemHtml = itemHtml.replace(/{{productImages}}/g, buildImages(product,product.images, product.handle, product.title, true));
						itemHtml = itemHtml.replace(/{{colorsList}}/g, '');
						itemHtml = itemHtml.replace(/{{colorsCount}}/g, '');
						itemHtml = itemHtml.replace(/{{sizesList}}/g, sizes);
						itemHtml = itemHtml.replace(/{{picturesList}}/g, pictures);
						//  sale label
						 itemHtml = itemHtml.replace(/{{saleLabelHtml}}/g, buildSaleLabel(product));
						// best Seller label
						itemHtml = itemHtml.replace(/{{BestSellerLabel}}/g, buildBestSellerLabel(product));


						if (productNewToSale.length > 0) {
							itemHtml = itemHtml.replace(/{{newSale}}/g, renderNewSale());
						} else {
							itemHtml = itemHtml.replace(/{{newSale}}/g, '');
						}

						if (recently_viewed_ids.includes(product.id)) {
							itemHtml = itemHtml.replace(/{{viewedLabel}}/g, boostPFSThemeConfig.label.badge_viewed);
						} else {
							itemHtml = itemHtml.replace(/{{viewedLabel}}/g, '');
						}


						itemHtml = itemHtml.replace(/ product-card__badge-wrapper--none/g, '');

						// Check if the collection page has the word sale, if it does do not output products that don't have a compare_at_price
						if(boostPFSAppConfig.general.collection_handle.includes('sale')) {
							if(product.compare_at_price_min) {
								templateProducts += itemHtml;
							}
						} else {
							templateProducts += itemHtml;
						}
					});

					let mobileProductWrapper = jQ('[data-product-card][data-product-handle="' + handle + '"]').prev();
					let mobileProductWrapperHtml = mobileProductWrapper.html().replace(/<product-cards><\/product-cards>/g, templateProducts);

					mobileProductWrapperHtml = mobileProductWrapperHtml.replace(/<div data-product-sale><\/div>/g, buildSaleLabel(product));

					mobileProductWrapperHtml = mobileProductWrapperHtml.replace(/<product-wrapper-title><\/product-wrapper-title>/g, product.title);
					mobileProductWrapperHtml = mobileProductWrapperHtml.replace(/<product-wrapper-price><\/product-wrapper-price>/g, '');
					mobileProductWrapper.html(mobileProductWrapperHtml);

					setTimeout(() => {
						document.dispatchEvent(
							new CustomEvent("bpf:product:render", {
								detail: {
									selector: document.querySelector(`[data-product-card][data-product-handle="${handle}"]`)
								}
							})
						);
					}, 1000)
					// $(document.querySelector(`[data-product-card][data-product-handle="${handle}"]`)).prev()[0].querySelectorAll('[data-product-card]').forEach((productMobileCard) => {
					// 	window.initProductCards(productMobileCard);

						// addedAccordion(productMobileCard);
					// });

					if(colorsCount > 5) {
						setTimeout(() => {
							const color_list = $('.product-card[data-id="'+product.id+'"] .product-card__color-list');
							color_list.on('init reInit', function(event, slick){
								color_list.parent().removeClass('card-scroll');
								const color_items = document.querySelectorAll('[data-id="'+product.id+'"] .product-card__color-list .product-card__color-item');
								const parser = new DOMParser();
								const parsed_colors = parser.parseFromString(colors, 'text/html');
								slick.$slider.addClass('first-slide');
								parsed_colors.querySelectorAll('.product-card__color-item').forEach((el, index) => {
									color_items[index].setAttribute('style', el.getAttribute('style'));
								});

								color_wrapper_items = document.querySelectorAll('[data-id="'+product.id+'"] .product-card__color-list .slick-slide:has(.product-card__color-item)');

								color_wrapper_items.forEach((el, index) => {
									el.addEventListener('click', function() {
										el.querySelector('.product-card__color-item').click();
									});
								});
							});

							$(window).on('resize orientationChange', function(event) { 
								color_list.slick('reinit');
							})

							color_list.on('beforeChange', function(event, slick, currentSlide, nextSlide){
								if(nextSlide == 0) {
									//console.log(slick.$list);
									slick.$slider.addClass('first-slide');
								} else {
									slick.$slider.removeClass('first-slide');
								}

								if (slick.$slides.length == nextSlide + slick.options.slidesToShow) {
									slick.$slider.addClass('last-slide');

								} else {
									slick.$slider.removeClass('last-slide');
								}

								if(!(nextSlide == 0 || slick.$slides.length == nextSlide + slick.options.slidesToShow)) {
									slick.$slider.addClass('not-first-or-last-slide');
								} else {
									slick.$slider.removeClass('not-first-or-last-slide');
								}
							});
							color_list.slick({
								infinite: false,
								prevArrow: `<button type="button" class="slick-prev"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16" class="icon icon-chevron"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 7.978a1.469 1.469 0 00-.42-1.019L3.199.401a1.364 1.364 0 00-1.983 0l-.81.847C.146 1.517 0 1.881 0 2.26s.146.743.406 1.011L5 7.978.405 12.714c-.26.268-.406.632-.406 1.011 0 .38.146.743.406 1.012l.81.832a1.365 1.365 0 001.983 0l6.383-6.558A1.468 1.468 0 0010 7.978z" fill="#000" /></svg></button>`,
								nextArrow: `<button type="button" class="slick-next"><svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10 16" class="icon icon-chevron"><path fill-rule="evenodd" clip-rule="evenodd" d="M10 7.978a1.469 1.469 0 00-.42-1.019L3.199.401a1.364 1.364 0 00-1.983 0l-.81.847C.146 1.517 0 1.881 0 2.26s.146.743.406 1.011L5 7.978.405 12.714c-.26.268-.406.632-.406 1.011 0 .38.146.743.406 1.012l.81.832a1.365 1.365 0 001.983 0l6.383-6.558A1.468 1.468 0 0010 7.978z" fill="#000" /></svg></button>`,
								mobileFirst: true,
								slidesToShow: 4,
								slidesToScroll: 4,
								responsive: [
									{
										breakpoint: 450,
										settings: {
											slidesToShow: 5,
											slidesToScroll: 5,
										}
									},
									{
										breakpoint: 570,
										settings: {
											slidesToShow: 6,
											slidesToScroll: 6,
										}
									},
									{
										breakpoint: 620,
										settings: {
											slidesToShow: 7,
											slidesToScroll: 7
										}
									},
									{
										breakpoint: 768,
										settings: {
											slidesToShow: 6,
											slidesToScroll: 6
										}
									},
									{
									breakpoint: 1230,
									settings: {
										slidesToShow: 12,
										slidesToScroll: 12
									}
									}
								]
							});
						}, 1000)
					}
					
					// Resolve promise when done
					resolve();
				},
				error: function() {
					// Still resolve on error to not block other products
					resolve();
				}
			});
		});
	}

	function renderBanners() {
		let productsCard = $('.collection-products > [data-product-card]');
		let banners = boostPFSThemeConfig.collectionBanners;
		const imageInGrid = boostPFSThemeConfig.collectionImageInGrid;
		const templateBannerItemHtml = boostPFSTemplate.bannerItemHtml;
		if (imageInGrid) {
			for (let bannerKeyBefore in imageInGrid) {
				let banner = imageInGrid[bannerKeyBefore];
				let bannerKey;

				if(+bannerKeyBefore === 0) {
					bannerKey = +bannerKeyBefore;
				} else {
					bannerKey = +bannerKeyBefore - 1;
				}

				if (!productsCard[bannerKey]) {
					break;
				}

				let styles = ``;
				if (banner.text_color) styles += `--text-color: ${banner.text_color};`;
				if (banner.button.text_color) styles += `--button-text-color: ${banner.button.text_color};`;
				if (banner.button.background_color) styles += `--button-background-color: ${banner.button.background_color};`;

				let bannerHtml= '';
				if(banner.show_alt_text) {
					bannerHtml = templateBannerItemHtml
						.replace(/{{bannerId}}/g, banner.id)
						.replace(/{{bannerKey}}/g, bannerKey)
						.replace(/{{bannerStyle}}/g, styles)
						.replace(/{{bannerTitle}}/g, banner.title)
						.replace(/{{bannerDescription}}/g, banner.description)
						.replace(/{{bannerCaption}}/g, banner.collection_image_text)
						.replace(/{{bannerLabel}}/g, '')
						.replace(/{{bannerStars}}/g, '')
						.replace(/{{position}}/g, '')
						.replace(/{{number_of_columns}}/g, banner.number_of_columns)
						.replace(/{{number_of_rows_mobile}}/g, banner.number_of_rows_mobile)
					;
				} else {
					bannerHtml = templateBannerItemHtml
						.replace(/{{bannerId}}/g, banner.id)
						.replace(/{{bannerKey}}/g, bannerKey)
						.replace(/{{bannerStyle}}/g, styles)
						.replace(/{{bannerTitle}}/g, banner.title)
						.replace(/{{bannerDescription}}/g, banner.description)
						.replace(/{{bannerCaption}}/g, banner.captions)
						.replace(/{{bannerLabel}}/g, '')
						.replace(/{{bannerStars}}/g, '')
						.replace(/{{position}}/g, '')
						.replace(/{{number_of_columns}}/g, banner.number_of_columns)
						.replace(/{{number_of_rows_mobile}}/g, banner.number_of_rows_mobile)
					;

				}

				if (banner.video_lightbox) {
					bannerHtml = bannerHtml
						.replace(/{{bannerButton}}/g, `<button data-video-url="${banner.video_lightbox}" class="banner__button ${banner.button.style} banner__button--play">${boostPFSThemeConfig.icons.playFilled}</button>`);
				}

				if (banner.video) {
					bannerHtml = bannerHtml
						.replace(/{{bannerImage}}/g, `<video muted="" autoplay="" playsinline="" loop=""><source src="${banner.video}" type="video/mp4"></video>`);
				} else if (banner.image) {
					if(banner.collection_image_mobile) {
						bannerHtml = bannerHtml
							.replace(/{{bannerImage}}/g, bannerBuildImage(banner.collection_image_mobile, banner.title));
					} else {
						bannerHtml = bannerHtml
							.replace(/{{bannerImage}}/g, bannerBuildImage(banner.image, banner.title));
					}

				} else {
						bannerHtml = bannerHtml
							.replace(/{{bannerImage}}/g, bannerBuildImage(banner.collection_image, banner.title));
				}
					bannerHtml = bannerHtml
						.replace(/{{bannerButton}}/g, '');


				// for (let bannerKeyOthers in banners) {
				// 	if (bannerKey > bannerKeyOthers) {
				// 		bannerKey = bannerKey - banners[bannerKeyOthers].number_of_columns;
				// 	}
				// }

				if (!$(productsCard[bannerKey]).next().data('banner') && $(productsCard[bannerKey]).next().data('banner') !== 0) {
					if(+bannerKeyBefore === 0) {
						if (!$(productsCard[bannerKey]).prev().data('banner') && $(productsCard[bannerKey]).prev().data('banner') !== 0) {
							$(productsCard[bannerKey]).before(bannerHtml);
						}
					} else {
						$(productsCard[bannerKey]).after(bannerHtml);
					}


					if (banner.video_lightbox){
						lightbox($(productsCard[bannerKey]).next());
					} else {
						bannerClick($(productsCard[bannerKey]).next(), banner.button.url);
					}
				}

				setTimeout(() => {
					const bannerShowButton = $('#'+banner.id + ' ' + banner.banner__button_show_content);

					if(bannerShowButton.length > 0) {
						bannerShowButton.off('click');
						bannerShowButton.click( (e)=> {
							e.preventDefault();
							e.stopPropagation();
							console.log($(e.target))
							$(e.target).parent().toggleClass('open')
						})
					}

					if(!banner.captions && !banner.collection_image_text) {
						bannerShowButton.hide();
					}

				},500)
			}
		}
	}

	function renderCollectionImageGrid() {
		let productsCard = $('.collection-products > [data-product-card]');
		let banners = boostPFSThemeConfig.collectionBanners;
		const templateBannerItemHtml = boostPFSTemplate.bannerItemGridHtml;

		for (let bannerKeyBefore in banners) {
			let banner = banners[bannerKeyBefore];
			let bannerKey;

			if(+bannerKeyBefore === 0) {
				bannerKey = +bannerKeyBefore;
			} else {
				bannerKey = +bannerKeyBefore - 1;
			}


			if(+bannerKey > +boostPFSFilterConfig.general.limit) {
				bannerKey = +boostPFSFilterConfig.general.limit - 1;
			}
			if (!productsCard[bannerKey]) {
				break;
			}

			let styles = ``;
			if (banner.text_color) styles += `--text-color: ${banner.text_color};`;
			if (banner.button.text_color) styles += `--button-text-color: ${banner.button.text_color};`;
			if (banner.button.background_color) styles += `--button-background-color: ${banner.button.background_color};`;
			let bannerHtml;
			const star = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="32" height="32" fill="white">
							  <polygon points="12,2 15,9 22,9 16.5,14 18.5,21 12,17 5.5,21 7.5,14 2,9 9,9"/>
							</svg>`
			let stars = star;
			for(let i=0; i<4; i++) {
				stars = stars + star;
			}
			if (banner.show_label) {
				if(banner.show_stars) {
					bannerHtml = templateBannerItemHtml
						.replace(/{{bannerId}}/g, banner.id)
						.replace(/{{bannerType}}/g, 'review')
						.replace(/{{bannerKey}}/g, bannerKey)
						.replace(/{{bannerStyle}}/g, styles)
						.replace(/{{bannerTitle}}/g, banner.title)
						.replace(/{{bannerDescription}}/g, banner.description)
						.replace(/{{bannerCaption}}/g, banner.captions)
						.replace(/{{bannerLabel}}/g, banner.text_label)
						.replace(/{{bannerStars}}/g, stars)
						.replace(/{{position}}/g, '')
						.replace(/{{number_of_columns}}/g, banner.number_of_columns)
						.replace(/{{number_of_rows_mobile}}/g, banner.number_of_rows_mobile)
					;
				} else {
					bannerHtml = templateBannerItemHtml
						.replace(/{{bannerId}}/g, banner.id)
						.replace(/{{bannerType}}/g, 'review')
						.replace(/{{bannerKey}}/g, bannerKey)
						.replace(/{{bannerStyle}}/g, styles)
						.replace(/{{bannerTitle}}/g, banner.title)
						.replace(/{{bannerDescription}}/g, banner.description)
						.replace(/{{bannerCaption}}/g, banner.captions)
						.replace(/{{bannerLabel}}/g, banner.text_label)
						.replace(/{{bannerStars}}/g, '')
						.replace(/{{position}}/g, '')
						.replace(/{{number_of_columns}}/g, banner.number_of_columns)
						.replace(/{{number_of_rows_mobile}}/g, banner.number_of_rows_mobile)
					;
				}

			} else {
				if(banner.show_stars) {
					bannerHtml = templateBannerItemHtml
						.replace(/{{bannerId}}/g, banner.id)
						.replace(/{{bannerType}}/g, 'review')
						.replace(/{{bannerKey}}/g, bannerKey)
						.replace(/{{bannerStyle}}/g, styles)
						.replace(/{{bannerTitle}}/g, banner.title)
						.replace(/{{bannerDescription}}/g, banner.description)
						.replace(/{{bannerCaption}}/g, banner.captions)
						.replace(/{{bannerLabel}}/g, '')
						.replace(/{{bannerStars}}/g, stars)
						.replace(/{{position}}/g, '')
						.replace(/{{number_of_columns}}/g, banner.number_of_columns)
						.replace(/{{number_of_rows_mobile}}/g, banner.number_of_rows_mobile)
					;
				} else {
					bannerHtml = templateBannerItemHtml
						.replace(/{{bannerId}}/g, banner.id)
						.replace(/{{bannerKey}}/g, bannerKey)
						.replace(/{{bannerStyle}}/g, styles)
						.replace(/{{bannerTitle}}/g, banner.title)
						.replace(/{{bannerDescription}}/g, banner.description)
						.replace(/{{bannerCaption}}/g, banner.captions)
						.replace(/{{bannerLabel}}/g, '')
						.replace(/{{bannerStars}}/g, '')
						.replace(/{{position}}/g, '')
						.replace(/{{number_of_columns}}/g, banner.number_of_columns)
						.replace(/{{number_of_rows_mobile}}/g, banner.number_of_rows_mobile)
					;
				}

			}


			if (banner.video_lightbox) {
				bannerHtml = bannerHtml
					.replace(/{{bannerButton}}/g, `<button data-video-url="${banner.video_lightbox}" class="banner__button ${banner.button.style} banner__button--play">${boostPFSThemeConfig.icons.playFilled}</button>`);
			}

			if (banner.video) {
				bannerHtml = bannerHtml
					.replace(/{{bannerImage}}/g, `<video muted="" autoplay="" playsinline="" loop=""><source src="${banner.video}" type="video/mp4"></video>`);
			} else if (banner.image) {
				bannerHtml = bannerHtml
					.replace(/{{bannerImage}}/g, bannerBuildImage(banner.image, banner.title));
			} else {
				if(banner.show_bg_image || !banner.isReviewBanner){
					bannerHtml = bannerHtml
						.replace(/{{bannerImage}}/g, bannerBuildImage(banner.collection_image, banner.title));
				} else {
					bannerHtml = bannerHtml
						.replace(/{{bannerImage}}/g, '');
				}

			}


			if (!banner.video_lightbox && banner.button.title ) {
				bannerHtml = bannerHtml
					.replace(/{{bannerButton}}/g, bannerBuildButton(banner.button));
			} else {
				bannerHtml = bannerHtml
					.replace(/{{bannerButton}}/g, '');
			}


			if (!$(productsCard[bannerKey]).next().data('banner') && $(productsCard[bannerKey]).next().data('banner') !== 0) {

				if(+bannerKeyBefore === 0) {
					if (!$(productsCard[bannerKey]).prev().data('banner') && $(productsCard[bannerKey]).prev().data('banner') !== 0) {
						$(productsCard[bannerKey]).before(bannerHtml);
					}
				} else {
					$(productsCard[bannerKey]).after(bannerHtml);
				}


				if (banner.video_lightbox){
					lightbox($(productsCard[bannerKey]).next());
				} else {
					bannerClick($(productsCard[bannerKey]).next(), banner.button.url);
				}
			} else {
				let banners = $('.collection-products > .banner');
				let bannerExists = banners.filter(function() {
					return $(this).attr('id') === banner.id;
				}).length > 0;

				if(!bannerExists) {
					$(productsCard[bannerKey]).next().after(bannerHtml)
				}
			}

			setTimeout(() => {
				const bannerShowButton = $('#'+banner.id + ' ' + banner.banner__button_show_content);

				if(bannerShowButton.length > 0) {
					bannerShowButton.off('click');
					bannerShowButton.click( (e)=> {
						e.preventDefault();
						e.stopPropagation();
						$(e.target).parent().toggleClass('open')
					})
				}

				if(!banner.captions) {
					bannerShowButton.hide();
				}
			},500)
		}
	}

	function lightbox(banner) {
		$(banner).find('[data-video-url]').closest('.banner__image-wrapper').click(function () {
			let lightbox = $(banner).find('[data-lightbox]');
			let src = $(this).find('[data-video-url]').data('videoUrl');

			lightbox.find('[data-lightbox-video]').html(`<iframe src="${src}" class="banner__lightbox-iframe" frameborder="0" allowfullscreen="1" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"></iframe>`);
			lightbox.addClass('banner__lightbox--open');

			lightbox.find('[data-lightbox-close]').click(function () {
				lightbox.removeClass('banner__lightbox--open');
				lightbox.find('[data-lightbox-video] iframe').remove();
			});
		});
	}

	function bannerClick(banner, url) {
		if(url) {
			const bannerCard = $(banner).find('.banner__image-wrapper');
			if(bannerCard){
				$(bannerCard).off('click').on('click', function (e) {
					location.href = url;
				});
				//console.log(`bannerCard`, bannerCard)
			}
		}
	}

	function bannerBuildButton(button) {
		let html = ``;

		html += `<a href="${button.url}" class="banner__button ${button.style}">${button.title}</a>`;

		return html;
	}

	function bannerBuildImage(image, alt = "Banner image") {
		let html = ``;

		html += `<picture>
        <source srcset="${Utils.optimizeImage(image, '375x500')} 1x, ${Utils.optimizeImage(image, '750x1000')} 2x" media="(max-width: 480px)">
        <source srcset="${Utils.optimizeImage(image, '768x1024')} 1x, ${Utils.optimizeImage(image, '1536x2048')} 2x" media="(max-width: 992px)">
        <source srcset="${Utils.optimizeImage(image, '1024x1366')} 1x, ${Utils.optimizeImage(image, '2048x2732')} 2x" media="(max-width: 1200px)">
        <source srcset="${Utils.optimizeImage(image, '1440x1920')} 1x, ${Utils.optimizeImage(image, '2880x3840')} 2x" media="(min-width: 1201px)">

        <img
            srcset="${Utils.optimizeImage(image, '1440x1920')} 1x, ${Utils.optimizeImage(image, '2880x3840')} 2x"
            src="${Utils.optimizeImage(image, '1440x1920')}"
            class="banner__image"
            alt="${alt}"
            loading="lazy"
        />
    </picture>`;

		return html;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/

	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item
	ProductGridItem.prototype.compileTemplate = function (data) {
		if (!data) data = this.data;
		// Customize API data to get the Shopify data
		data = prepareShopifyData(data);

		let groupId = data.tags.find(item => item.indexOf('YGroup_') !== -1);
		let hasStichId = !!data.tags.find(item => item.indexOf('YGroup_') !== -1);;
		var stitchId = groupId?.split('YGroup_')[1];
		let newCollection = data.original_tags.filter(item => item === "collection:New");
		let newToSale = data.original_tags.filter(item => item === "new-sale");


		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		var mobileProductWrapper = boostPFSTemplate.mobileProductWrapper;


		itemHtml = itemHtml.replace(/{{productHandle}}/g, data.handle);

		itemHtml = itemHtml.replace(/{{productTitle}}/g, data.title.replace(/\?/g, '®'));


		let compareAtPrice = buildCompareAtPrice(data);
		itemHtml = itemHtml.replace(/{{productOnSale}}/g, buildSale(data))
		itemHtml = itemHtml.replace(/{{productCompareAtPrice}}/g, compareAtPrice.html);
		itemHtml = itemHtml.replace(/{{productCompareAtPriceHandle}}/g, compareAtPrice.hiddenClass);

		itemHtml = itemHtml.replace(/{{productPrice}}/g, buildPrice(data));

		itemHtml = itemHtml.replace(/{{viewedLabel}}/g, boostPFSThemeConfig.label.badge_viewed);
		// sale label
		itemHtml = itemHtml.replace(/{{saleLabelHtml}}/g, buildSaleLabel(data));
		// best Seller label
		itemHtml = itemHtml.replace(/{{BestSellerLabel}}/g, buildBestSellerLabel(data));

		if (newToSale.length > 0) {
			itemHtml = itemHtml.replace(/{{newSale}}/g, renderNewSale());
		} else {
			itemHtml = itemHtml.replace(/{{newSale}}/g, '');
		}


		itemHtml = itemHtml.replace(/{{newLabel}}/g, boostPFSThemeConfig.label.badge_new);

		if (hasStichId) {
			itemHtml = itemHtml.replace(/{{productImages}}/g, '<productimages></productimages>');
			itemHtml = itemHtml.replace(/{{colorsList}}/g, '<colorslist></colorslist>');
			itemHtml = itemHtml.replace(/{{sizesList}}/g, '<sizesList></sizesList>');
			itemHtml = itemHtml.replace(/{{colorsCount}}/g, '<colorscount></colorscount>');
			itemHtml = itemHtml.replace(/{{picturesList}}/g, '<pictureslist></pictureslist>');

			itemHtml = itemHtml.replace(/{{mobileProductWrapper}}/g, mobileProductWrapper);
			if (stitchId) {
				itemHtml = itemHtml.split(/{{stitchId}}/g).join(stitchId);
			}


			compiteProductGroupCard(data, data.handle);

			setTimeout(() => {
				if (window.innerWidth > 768) {
					document.querySelectorAll('.product-card--boost').forEach(function(element) {
						const image_wrapper = element.querySelector('.product-card__image-wrapper');

						image_wrapper.addEventListener('mouseover', function(evt) {
							evt.currentTarget.closest('.product-card--boost').classList.add('first-hover');
						});
						image_wrapper.addEventListener('mouseleave', function(evt) {
							evt.currentTarget.closest('.product-card--boost').classList.remove('first-hover');
						});
					})
				}
			}, 5000);

			setTimeout(() => {
				if (window.innerWidth <= 768) {
					document.querySelectorAll('.product-card--boost').forEach(function(element) {
						if(element.getAttribute('data-product-handle') == "egiftcard") {
							element.querySelector('.quick-add-mobile').style.display = "none";
						}
					});
				}
			}, 2000);
		} else {
			itemHtml = itemHtml.replace(/{{productImages}}/g, buildImages(data,data.images, data.handle, data.title));
			itemHtml = itemHtml.replace(/{{colorsList}}/g, '');
			itemHtml = itemHtml.replace(/{{sizesList}}/g, '');
			itemHtml = itemHtml.replace(/{{colorsCount}}/g, '1 ' + boostPFSThemeConfig.label.count_color);
			itemHtml = itemHtml.replace(/{{picturesList}}/g, '<pictureslist></pictureslist>');
			buildPictures(data, data.handle);

			itemHtml = itemHtml.replace(/{{mobileProductWrapper}}/g, '');
		}

		return itemHtml;
	};
	/************************** END BUILD PRODUCT LIST **************************/

	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildImages(data, images, handle, alt, test = false) {
		let html = ``;

    	if (!Array.isArray(images)) images = data.images_info;

        if (images.length ===0) return `
            <a href="/products/${handle}" class="product-card__images-box product-card__images-box--show"></a>
        `;

		let imageFirst = images[0].src ?? images[1].src;
		let imageLast = images[1]?.src || images[data.images.length - 1]?.src;

		let activeImage = 'product-card__images-box--show';

		html += `
			<a href="/products/${handle}" class="product-card__images-box ${activeImage}">
				<div class="product-card__image-first">
					<picture>
						<source srcset="${Utils.optimizeImage(imageFirst, '575x')} 1x, ${Utils.optimizeImage(imageFirst, '1150x')} 2x" media="(max-width: 575px)">
						<source srcset="${Utils.optimizeImage(imageFirst, '350x')} 1x, ${Utils.optimizeImage(imageFirst, '700x')} 2x" media="(max-width: 767px)">
						<source srcset="${Utils.optimizeImage(imageFirst, '305x')} 1x, ${Utils.optimizeImage(imageFirst, '610x')} 2x" media="(max-width: 992px)">
						<source srcset="${Utils.optimizeImage(imageFirst, '265x')} 1x, ${Utils.optimizeImage(imageFirst, '530x')} 2x" media="(max-width: 1200px)">
						<source srcset="${Utils.optimizeImage(imageFirst, '465x')} 1x, ${Utils.optimizeImage(imageFirst, '930x')} 2x" media="(max-width: 1800px)">
						<source srcset="${Utils.optimizeImage(imageFirst, '375x')} 1x, ${Utils.optimizeImage(imageFirst, '750x')} 2x" media="(max-width: 1920px)">

						<img
							srcset="${Utils.optimizeImage(imageFirst, '375x')} 1x, ${Utils.optimizeImage(imageFirst, '750x')} 2x"
							src="${Utils.optimizeImage(imageFirst, '375x')}"
							class="product-card__image"
							alt="${alt}"
							loading="lazy"
						/>
					</picture>
				</div>

				<div class="product-card__image-last">
					<picture>
						<source srcset="${Utils.optimizeImage(imageLast, '575x')} 1x, ${Utils.optimizeImage(imageLast, '1150x')} 2x" media="(max-width: 575px)">
						<source srcset="${Utils.optimizeImage(imageLast, '350x')} 1x, ${Utils.optimizeImage(imageLast, '700x')} 2x" media="(max-width: 767px)">
						<source srcset="${Utils.optimizeImage(imageLast, '305x')} 1x, ${Utils.optimizeImage(imageLast, '610x')} 2x" media="(max-width: 992px)">
						<source srcset="${Utils.optimizeImage(imageLast, '265x')} 1x, ${Utils.optimizeImage(imageLast, '530x')} 2x" media="(max-width: 1200px)">
						<source srcset="${Utils.optimizeImage(imageLast, '465x')} 1x, ${Utils.optimizeImage(imageLast, '930x')} 2x" media="(max-width: 1800px)">
						<source srcset="${Utils.optimizeImage(imageLast, '375x')} 1x, ${Utils.optimizeImage(imageLast, '750x')} 2x" media="(max-width: 1920px)">

						<img
							srcset="${Utils.optimizeImage(imageLast, '375x')} 1x, ${Utils.optimizeImage(imageLast, '750x')} 2x"
							src="${Utils.optimizeImage(imageLast, '375x')}"
							class="product-card__image"
							alt="${alt}"
							loading="lazy"
						/>
					</picture>
				</div>
			</a>
			`;

		return html;
	}

	function buildBadge(data) {
		let html = '';

		return html;
	}

	function buildCardProductClass() {
		var html = '';
		if (!images || (images && images.length === 0)) {
			html = 'card--text-only card--soft';
		} else if (boostPFSThemeConfig.custom.hasOwnProperty('show_image_outline') && boostPFSThemeConfig.custom.show_image_outline) {
			html = 'card--outline';
		}
		return html;
	}

	function buildVendor(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_vendor') &&
			boostPFSThemeConfig.custom.show_vendor === true) {
			html = boostPFSTemplate.vendorHtml;
		}
		return html;
	}

	function buildCompareAtPrice(data) {
		var html = '';
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var priceAmount = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min, 'money_with_currency') : Utils.formatMoney(data.price_min);
		var compareAtPrice = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') : Utils.formatMoney(data.compare_at_price_min);
		var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount)
			: priceAmount;
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : '';
		html = `${compareAtPrice.replace('AUD', '').replace('NZD', '')}`;

		let hiddenClass = 'hidden';
		if (data.compare_at_price_min > data.price_min) {
			hiddenClass = '';
		}

		return {html: html, hiddenClass: hiddenClass};
	}
	function buildSale(data) {
		var html = '';
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var priceAmount = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min, 'money_with_currency') : Utils.formatMoney(data.price_min);
		var compareAtPrice = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') : Utils.formatMoney(data.compare_at_price_min);
		var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount)
			: priceAmount;
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : '';


		let hiddenClass = 'hidden';
		if (data.compare_at_price_min > data.price_min) {
			html = 'sale_price';
		}

		return html;
	}

	function buildPrice(data) {
		var html = '';
		var noComparePrice = data.price_varies === false && data.compare_at_price_varies;
		var priceAmount = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.price_min, 'money_with_currency') : Utils.formatMoney(data.price_min);
		var compareAtPrice = boostPFSConfig.custom.currency_code_enabled ? Utils.formatMoney(data.compare_at_price_min, 'money_with_currency') : Utils.formatMoney(data.compare_at_price_min);
		var moneyPrice = priceVaries ? boostPFSConfig.label.from_price_html.replace(/{{ price }}/, priceAmount)
			: priceAmount;
		var unitPriceClass = !data.available || typeof data?.selected_or_first_available_variant?.unit_price_measurement === 'undefined' ? 'hidden' : '';
		html = `${moneyPrice.slice(0, -4)}`;

		return html;
	}

	function buildSoldOutLabel() {
		// Build Sold out label
		var soldOutLabel = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('sold_out_badge_color_scheme') && soldOut) {
			soldOutLabel = boostPFSTemplate.soldOutLabelHtml.replace(/{{soldOutBadgeClass}}/g, boostPFSThemeConfig.custom.sold_out_badge_color_scheme);
		}
		return soldOutLabel;
	}

	function buildSaleLabel(data) {
		// Build Sale label
		var saleLabel = '';
		var percentage = data.price_min / data.compare_at_price_min;
		percentage = (1 - percentage).toFixed(2) * 100;
		saleLabel += '<div class="product-card__badge-wrapper--none product-card__badge-wrapper product-card__badge-wrapper--sale" data-product-sale> <div class="product-card__badge">'+ percentage +'% Off</div></div>';
		return saleLabel;
	}
	function buildBestSellerLabel(data) {
		// Build Best Seller label

		var bestSellerLabel = '';
				if (data.tags) {
					for (var i = data.tags.length - 1; i >= 0; i--) {
						tag = data.tags[i];
						if (tag.indexOf("collection:Favourites") !== -1) {
							//var preTagLabel = boostPFSTemplate.tagLabelHtml.replace(/{{labelTag}}/g, tag.split('pfs:label-')[1]);
							bestSellerLabel += '<div class="product-card__badge-wrapper product-card__badge-wrapper--none product-card__badge-wrapper--best-seller" data-product-best-seller> <div class="product-card__badge">Best Seller</div></div>';
							break;
						}
					}
				}
		return bestSellerLabel;
	}

	function buildReview(data) {
		var html = '';
		if (boostPFSThemeConfig.custom.hasOwnProperty('show_product_review') &&
			boostPFSThemeConfig.custom.show_product_review == true && Utils.getProductMetafield(data, 'reviews', 'rating') !== null) {
			var ratingObj = JSON.parse(Utils.getProductMetafield(data, 'reviews', 'rating'));
			var rating_decimal = 0;
			var decimal = parseFloat(ratingObj.value.rating);
			if (decimal >= 0.3 && decimal <= 0.7) {
				rating_decimal = 0.5;
			} else if (decimal > 0.7) {
				rating_decimal = 1;
			}
			html = `<div class="rating" role="img" aria-label="${boostPFSConfig.label.star_reviews_info.replace('{{ rating_value }}', ratingObj.value).replace('{{ rating_max }}', ratingObj.value.scale_max)}">
                <span aria-hidden="true" class="rating-star color-icon-${boostPFSConfig.custom.accent_icons}" style="--rating: ${Math.round(ratingObj.value.rating)}; --rating-max: ${ratingObj.value.scale_max}; --rating-decimal: ${rating_decimal};"></span>
              </div>
              <p class="rating-text caption">
                <span aria-hidden="true">${ratingObj.value} / ${ratingObj.value.scale_max}</span>
              </p>
              <p class="rating-count caption">
                <span aria-hidden="true">(${Utils.getProductMetafield(data, 'reviews', 'rating_count')})</span>
                <span class="visually-hidden">${Utils.getProductMetafield(data, 'reviews', 'rating_count')} ${boostPFSConfig.label.total_reviews}</span>
              </p>`;
		}
		return html;
	}



	// Batch picture requests for better performance
	const pictureQueue = [];
	let pictureTimer = null;
	
	function buildPictures(data, handle) {
		let pictures = [];

		data.tags.forEach((tag) => {
			if (tag.includes('picture:') && !pictures.includes(tag)) {
				pictures.push(tag);
			}
		});
		
		if (pictures.length === 0) return true;

		// Add to queue
		pictureQueue.push({ handle, pictures });
		
		// Debounce batch processing
		if (pictureTimer) clearTimeout(pictureTimer);
		pictureTimer = setTimeout(processPictureQueue, 50);

		return true;
	}
	
	function processPictureQueue() {
		if (pictureQueue.length === 0) return;
		
		// Group by similar picture tags for batch requests
		const groupedRequests = {};
		
		pictureQueue.forEach(({ handle, pictures }) => {
			const key = pictures.join('|');
			if (!groupedRequests[key]) {
				groupedRequests[key] = [];
			}
			groupedRequests[key].push(handle);
		});
		
		// Clear queue
		pictureQueue.length = 0;
		
		// Make batch requests
		Object.entries(groupedRequests).forEach(([pictureTag, handles]) => {
			jQ.ajax({
				type: "GET",
				url: `/?section_id=product-card-pictures&tag=${pictureTag}`,
				success: function (response) {
					const html = document.createElement("div");
					html.innerHTML = response;
					let picturesHtml = html.querySelector("#shopify-section-product-card-pictures").innerHTML;
					
					// Update all products with same pictures
					handles.forEach(handle => {
						let card = jQ('[data-product-card][data-product-handle="' + handle + '"]');
						let templateHTML = card.html();
						templateHTML = templateHTML.replace(/<pictureslist><\/pictureslist>/g, picturesHtml);
						card.html(templateHTML);
					});
				}
			});
		});
	}

	function renderNewBadge() {
		let html = boostPFSTemplate.newBadge;

		html = html.replace(/{{newLabel}}/g, boostPFSThemeConfig.label.badge_new);

		return html;
	}

	function renderNewSale() {
		let html = boostPFSTemplate.newSale;

		html = html.replace(/{{newSaleLabel}}/g, boostPFSThemeConfig.label.new_sale);

		return html;
	}

	// function addedAccordion(productCard) {
	// 	let container = productCard.querySelector('.js-toggle-accordion');
	// 	let button = container.querySelector('.js-toggle-button');
	// 	let content = container.querySelector('.js-toggle-content');
	//
	// 	container.style.setProperty('--max-height', `${content.scrollHeight}px`);
	//
	// 	button.addEventListener('click', (e) => {
	// 		e.preventDefault();
	//
	// 		content.classList.toggle('product-card__sizes-box--open');
	// 	});
	// }

	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/

	/************************** BUILD PRODUCT GROUP **************************/
	function buildImagesGroup(group, productId) {
		let html = ``;

		group.forEach((product, groupKey) => {
			let imageFirst = product.images[0]?.src;
			let imageLast = product.images[1]?.src || product.images[product.images.length - 1]?.src;

			let activeImage = '';
			if (product.id === productId)
				activeImage = 'product-card__images-box--show';

			html += `
			<a href="/products/${product.handle}" class="product-card__images-box ${activeImage}" data-product-img="${++groupKey}">
				<div class="product-card__image-first">
					<picture>
						<source srcset="${Utils.optimizeImage(imageFirst, '575x')} 1x, ${Utils.optimizeImage(imageFirst, '1150x')} 2x" media="(max-width: 575px)">
						<source srcset="${Utils.optimizeImage(imageFirst, '350x')} 1x, ${Utils.optimizeImage(imageFirst, '700x')} 2x" media="(max-width: 767px)">
						<source srcset="${Utils.optimizeImage(imageFirst, '305x')} 1x, ${Utils.optimizeImage(imageFirst, '610x')} 2x" media="(max-width: 992px)">
						<source srcset="${Utils.optimizeImage(imageFirst, '265x')} 1x, ${Utils.optimizeImage(imageFirst, '530x')} 2x" media="(max-width: 1200px)">
						<source srcset="${Utils.optimizeImage(imageFirst, '465x')} 1x, ${Utils.optimizeImage(imageFirst, '930x')} 2x" media="(max-width: 1800px)">
						<source srcset="${Utils.optimizeImage(imageFirst, '375x')} 1x, ${Utils.optimizeImage(imageFirst, '750x')} 2x" media="(max-width: 1920px)">

						<img
							srcset="${Utils.optimizeImage(imageFirst, '375x')} 1x, ${Utils.optimizeImage(imageFirst, '750x')} 2x"
							src="${Utils.optimizeImage(imageFirst, '375x')}"
							class="product-card__image"
							alt="${product.title}"
							loading="lazy"
						>
					</picture>
				</div>

				<div class="product-card__image-last">
					<picture>
						<source srcset="${Utils.optimizeImage(imageLast, '420x')} 1x, ${Utils.optimizeImage(imageLast, '840x')} 2x" media="(max-width: 575px)">
						<source srcset="${Utils.optimizeImage(imageLast, '350x')} 1x, ${Utils.optimizeImage(imageLast, '700x')} 2x" media="(max-width: 767px)">
						<source srcset="${Utils.optimizeImage(imageLast, '305x')} 1x, ${Utils.optimizeImage(imageLast, '610x')} 2x" media="(max-width: 992px)">
						<source srcset="${Utils.optimizeImage(imageLast, '265x')} 1x, ${Utils.optimizeImage(imageLast, '530x')} 2x" media="(max-width: 1200px)">
						<source srcset="${Utils.optimizeImage(imageLast, '465x')} 1x, ${Utils.optimizeImage(imageLast, '930x')} 2x" media="(max-width: 1800px)">
						<source srcset="${Utils.optimizeImage(imageLast, '375x')} 1x, ${Utils.optimizeImage(imageLast, '750x')} 2x" media="(max-width: 1920px)">

						<img
							srcset="${Utils.optimizeImage(imageLast, '375x')} 1x, ${Utils.optimizeImage(imageLast, '750x')} 2x"
							src="${Utils.optimizeImage(imageLast, '375x')}"
							class="product-card__image"
							alt="${product.title}"
							loading="lazy"
						>
					</picture>
				</div>
			</a>
			`;
		});

		return html;
	}

	function buildColorsGroup(group, productId) {
		let colors = [];

		group.forEach((product) => {
			colors.push({
				productId: product.id,
				image: product.images[0]?.src,
				hex: product.colorHex,
				sku: product.colorSKU,
				title: product.title
			});
		});

		let html = ``;
		colors.forEach((color, colorKey) => {
			let templateColor = boostPFSTemplate.productGridItemColorHtml;

			templateColor = templateColor.replace(/{{colorTitle}}/g, color.title);
			templateColor = templateColor.replace(/{{colorActive}}/g, (color.productId === productId) ? 'product-card__color-item--active' : '');
			templateColor = templateColor.replace(/{{color}}/g, ((color.hex) ? color.hex : color.sku ? color.sku : '#fff'));
			if (!color.sku && !color.hex) templateColor = templateColor.replace(/{{colorImage}}/g, `--background-image: url('${color.image}');`);
			else templateColor = templateColor.replace(/{{colorImage}}/g, '');
			templateColor = templateColor.replace(/{{colorKey}}/g, ++colorKey);

			html += templateColor;
		});

		if (colors.length < 1) colors.push('Default');

		return {
			colors: html,
			colorsCount: colors.length
		};
	}

	function buildSizesGroup(group, productId, productData) {
		if ((productData.template_suffix !== null && productData.template_suffix === 'surfboard') || productData.tags.includes('product:is-quote')) return ''; 
		let htmlSizes = '<div class="quick-add-text">Quick Add</div>';

		group.forEach((product, productKey) => {
			let sizes = '';
			let optionParam = null;
			let size_found = false;

			product.options.forEach((option, optionId) => {
				if (option.name === 'Size' || option.name == 'Size (Womens Waders)' || option.name == 'Size (Mens Waders)') {
					optionParam = 'option'+option.position;
					size_found = true;
				}
			});

			if(size_found) {
				sizes = `<ul class="product-card__sizes-list ${(productId === product.id) ? 'product-card__sizes-list--active': ''}" data-product-size="${productKey+1}">`;
				product.variants.forEach((variant) => {
					sizes += `<li class="product-card__sizes-item ${(!variant.available) ? 'product-card__sizes-item--disabled' : ''}" ${(variant.available) ? 'data-product-fastadd="true"' : ''} data-product-handle="${product.handle}" data-product-variant="${variant.id}">
								<span>${variant[optionParam]}</span>
							  </li>`;
				});
				sizes += '</ul>';

				htmlSizes += sizes;
			}
		});

		return htmlSizes;
	}

	function buildColorName(product) {
		let color = product.options.find((option) => option.name === 'Color' || option.name === 'Colour');

		if (color)
			return color.values[0];
		else
			return '';
	}

	function buildJsonGroup(group) {
		let json = [];

		group.forEach((product) => {
			json.push({
				id: product.id,
				price: product.price,
				compareAtPrice: (product.compare_at_price) ? product.compare_at_price : 0,
				tags: product.tags,
				handle: product.handle
			});
		});

		return json;
	}

	function buildPicturesGroup(group) {
		let pictures = [];

		group.forEach((product) => {
			product.tags.forEach((tag) => {
				if (tag.includes('picture:') && !pictures.includes(tag)) {
					pictures.push(tag);
				}
			});
		});

		return pictures.join('|');
	}

	/************************** END BUILD PRODUCT GROUP **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;
		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : '';
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : '';
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
		// Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}
		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

		loadMorePageInSearchPage();
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				var paramSort = Globals.queryParams.sort || '';
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var isSelected = '';
					if (paramSort == k) {
						isSelected = 'sort-by__item--active';

						jQ(Selector.topSorting).addClass('sort-by--open');
					}
					sortingItemsHtml += '<li data-value="' + k + '" class="sort-by__item ' + isSelected + '">' + sortingArr[k] + '</li>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	ProductSorting.prototype.render = function () {
		jQ(Selector.topSorting).html(this.compileTemplate());

		if (jQ('.sort-by__active-text').hasClass('sort-by__active-text--active')) {
			jQ('.sort-by__active-text').toggleClass('sort-by__active-text--active');
		}

		var labelSort = '';
		var paramSort = Globals.queryParams.sort || '';
		var sortingList = Utils.getSortingList();
		if (paramSort.length > 0 && sortingList && sortingList[paramSort]) {
			labelSort = sortingList[paramSort];
		} else {
			labelSort = Labels.sorting_heading;
		}

		jQ('.sort-by__active-text').text(labelSort);
	};

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function () {
		jQ(Selector.topSorting + ' .sort-by__item').click(function (e) {
			e.preventDefault();
			window.scroll(0, jQ('.collection-wrapper')[0].offsetTop);
			FilterApi.setParam('sort', jQ(this).data('value'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
		});

		jQ(Selector.topSorting + ' .sort-by__title').click(function (e) {
			jQ(this).closest('.sort-by').toggleClass('sort-by--open');
		});
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data) {
		if (!data) data = this.data;

		// Handle visibility optimizations
		requestAnimationFrame(() => {
			if (!data.length) {
				if (window.innerWidth > 768) {
					jQ('.collection-filters').addClass('boost-hidden');
				}
			} else {
				if (window.innerWidth > 768) {
					jQ('.collection-filters.boost-hidden').removeClass('boost-hidden');
				}
			}

			// Lazy loading is now handled by browser's native loading="lazy" attribute

			// Render banners and grid asynchronously
			setTimeout(() => {
				renderBanners();
				renderCollectionImageGrid();
			}, 0);

			// Handle search page elements
			const empty_search = document.querySelector('.boost-pfs-filter-message.result-empty-search');
			const product_cards = document.querySelector('.template-search .content-cards');
			const nosto_slider = document.querySelector('.template-search [data-nosto-section]');

			if(empty_search){
				if (product_cards) product_cards.style.display = 'block';
				if (nosto_slider) nosto_slider.style.display = 'none';
			}else{
				if (product_cards) product_cards.style.display = 'none';
				if (nosto_slider) nosto_slider.style.display = 'block';
			}

			// Remove loading state
			document.querySelector('.collection-wrapper').classList.remove('is-loading');
		});

		// Event delegation for better performance
		if (!this._eventsAttached) {
			this._eventsAttached = true;
			
			jQ('body').on('click', '.js-filter-banner', function () {
				if (window.innerWidth > 768) {
					location.hash = '';
					location.hash = 'collection';
				} else {
					jQ('.boost-pfs-filter-tree-mobile-button button').click();
				}
			});

			jQ('body').on('click', '.od-filter-cta-button', function (e) {
				e.preventDefault();
				jQ('.boost-pfs-filter-tree-mobile-button button').click();
			});
		}
	};

	let countRefineByItem = 0;
	// Build Additional Elements
	Filter.prototype.afterRender = function (data, eventType) {
		if (!data) data = this.data;

		setTimeout(() => {
			const collectionProducts = $('.collection-products.boost-pfs-filter-products');
			const productCardInitialized = collectionProducts.find('.product-card--initialized');
			const productCardInitializedQty = productCardInitialized.length;
			const loadMoreTotalBlock = $('.boost-pfs-filter-load-more-total');
			const collectionContentTotal = $('.collection-content .total-products')
			const totalProduct = data.total_product;
			const product = totalProduct == 1? ' Product' : ' Products';

			let progressBarTrack = $('<span>', {
				class: 'collection__pagination-progress-bar-track'
			});
			let progressBarIndicator = $('<span>', {
				class: 'collection__pagination-progress-bar-indicator',
				'data-pagination-progress-indicator': ''
			});

			collectionContentTotal.text(totalProduct + product);

			progressBarIndicator.appendTo(progressBarTrack);

			if (loadMoreTotalBlock.length && !loadMoreTotalBlock.find('.collection__pagination-progress-bar-track').length) {
				loadMoreTotalBlock.append(progressBarTrack);
			}

			document.querySelectorAll('.collection-products.boost-pfs-filter-products .product-card').forEach(card => {
				card.addEventListener("click", function() {
					const dataId = card.getAttribute('data-id');
					window.localStorage.setItem('backScrollTo', dataId);
				})
			});

			let progressPercentage = (productCardInitializedQty / totalProduct) * 100;
			progressBarIndicator.css('width', progressPercentage + '%');

		},2000)

		jQ('.boost-pfs-filter-total-product').html(data.total_product + ' products');

		let categorySelected = jQ('.boost-pfs-filter-option-category .boost-pfs-filter-option-label.selected .boost-pfs-filter-option-value').text();
		jQ('.boost-pfs-filter-mobile-toolbar-header').text((categorySelected) ? categorySelected : 'All');

		setTimeout(function () {
			document.dispatchEvent(
				new CustomEvent("bpf:filter:afterRender", {
					detail: {
						filter: data
					}
				})
			);
		}, 100);

		// let sizeOption = jQ('.boost-pfs-filter-option-size .boost-pfs-filter-option-title-count').first();
		// if (sizeOption.text().length) {
		// 	sizeOption.closest('.boost-pfs-filter-option-title-text').addClass('js-remove-after');
		// } else {
		// 	sizeOption.closest('.boost-pfs-filter-option-title-text').removeClass('js-remove-after');
		// }

		jQ('.collection-filters .boost-pfs-filter-tree-mobile-open .boost-pfs-filter-show-result').text('Apply').addClass('boost-pfs-filter-show-result--apply').data('scroll', true);

		jQ('.boost-pfs-filter-options-wrapper .boost-pfs-filter-option:last-child').hover(function () {
			jQ('.sort-by').addClass('filter-hover');
		}, function () {
			jQ('.sort-by').removeClass('filter-hover');
		});

		let filters_count_object = jQ('.boost-pfs-filter-option-title-count');

		let filters_count = -1;
		if (location.pathname.indexOf('search') !== -1) filters_count++;

		jQ.each(filters_count_object, function (index, value) {
			let filter_count = +value.innerText;
			if (filter_count > 0) {
				jQ(value).closest('.boost-pfs-filter-option-title-text').addClass('js-remove-after');
			} else {
				jQ(value).closest('.boost-pfs-filter-option-title-text').removeClass('js-remove-after');
			}
			filters_count += filter_count;
		});
		if (filters_count > 0) {
			jQ('.js-boost-filters-count').text(' (' + filters_count + ')');
			jQ('#SortBy [data-value="relevance"]').css({'display': 'block'});

			if (jQ('.collection-wrapper .boost-pfs-filter-mobile-footer .boost-pfs-filter-clear-all').length === 0) {
				let buttonClearFilters = `
					<button class="boost-pfs-filter-clear-all" type="button">Clear All</button>
				`;
				jQ('.collection-wrapper .boost-pfs-filter-mobile-footer').append(buttonClearFilters);
			}
		} else {
			jQ('.js-boost-filters-count').text('');
			jQ('#SortBy [data-value="relevance"]').css({'display': 'none'});

			jQ('.collection-wrapper .boost-pfs-filter-mobile-footer .boost-pfs-filter-clear-all').remove();
		}

		renderBanners();
		renderCollectionImageGrid();

		jQ('.js-filters-mobile-bottom .filters-mobile__button').click(function () {
			jQ('.js-filters-mobile-top .boost-pfs-filter-tree-mobile-button button').click();
		});

		let mobileToolbarHeader = jQ('.boost-pfs-filter-mobile-toolbar-header');

		if (mobileToolbarHeader.text() === 'All') {
			mobileToolbarHeader.text('');
		}

		if (countRefineByItem !== $('.refine-by-item').length) {
			if (window.innerWidth > 768) {
				countRefineByItem = $('.refine-by-item').length;
				location.hash = '';
				location.hash = 'collection';
			}
		}


		var divsToMove = document.getElementsByClassName('product-card__sizes-box__show');
		var newParentElements = document.getElementsByClassName('collection-content');

		divsToMove.forEach(function(divToMove, index) {
		  var parentElement = divToMove.parentNode;
		  var newParentElement = newParentElements[index];
		  parentElement.removeChild(divToMove);
		  newParentElement.appendChild(divToMove);
		});


		$(document).on("click", ".quick-add-mobile", function(event) {
            $(event.target).closest('.product-card__content').find('.myModal').css('display', 'block');
			$("body").css("overflow", "hidden");
        });

		$(document).on("click", ".myModal .close", function(event) {
			$('.myModal').css('display', 'none');
			$("body").css("overflow", "auto");
		});

		$(document).on("click", ".product-card__sizes-item", function(event) {
			setTimeout(function() {
				$('.myModal').css('display', 'none');
			}, 1500);
			$("body").css("overflow", "auto");
		});
		if (window.innerWidth < 768) {
			const sorting = document.querySelector(".boost-pfs-filter-top-sorting");
			const wrapper = document.querySelector(".boost-pfs-filter-options-wrapper");

			if (sorting && wrapper) {
				if (!wrapper.querySelector(".special-sort-by-filter-drawer")) {
					const clone = sorting.cloneNode(true);
					clone.classList.add("special-sort-by-filter-drawer");
					wrapper.appendChild(clone);
				}
			}
		}

	};

	jQ('.collection-wrapper').on('click', '.boost-pfs-filter-mobile-footer .boost-pfs-filter-show-result', function () {
		if ($(this).data('scroll')) {
			location.hash = '';
			location.hash = 'collection';
		}
		jQ('.boost-pfs-filter-mobile-footer .boost-pfs-filter-show-result').text('Close Filter').removeClass('boost-pfs-filter-show-result--apply').data('scroll', false);
	});

	jQ('.collection-wrapper').on('click', '.boost-pfs-filter-mobile-footer .boost-pfs-filter-clear-all', function () {
		jQ('.boost-pfs-filter-mobile-toolbar .boost-pfs-filter-mobile-toolbar-bottom button').click();
	});

	/************************** END BUILD TOOLBAR **************************/

	checkScroll();

	function checkScroll() {
		if (location.pathname === '/search') {

			let filterMobileTop = document.querySelector('.js-filters-mobile-top');
			let filterMobileBottom = document.querySelector('.js-filters-mobile-bottom');

			window.addEventListener('scroll', function (e) {
				if (window.pageYOffset > filterMobileTop.offsetHeight + filterMobileTop.offsetTop) {
					filterMobileBottom.style.display = 'flex';
				} else {
					filterMobileBottom.style.display = 'none';
				}
			});
		}

		if (location.pathname.indexOf('collections') !== -1) {
			let jsFilterBanner = document.querySelector('[data-banner-content]');
			let filtersMobile = document.querySelector('.filters-mobile');

			const checkStatus = () => {
				if (window.pageYOffset < jsFilterBanner?.offsetHeight + jsFilterBanner?.offsetTop) {
					filtersMobile.style.display = 'none';
				} else {
					filtersMobile.style.display = '';
				}
			};

			checkStatus();

			window.addEventListener('scroll', function (e) {
				checkStatus();
			});
		}
	}

	function simulatedClick(target, options) {

		var event = target.ownerDocument.createEvent('MouseEvents'),
			options = options || {},
			opts = { // These are the default values, set up for un-modified left clicks
				type: 'click',
				canBubble: true,
				cancelable: true,
				view: target.ownerDocument.defaultView,
				detail: 1,
				screenX: 0, //The coordinates within the entire page
				screenY: 0,
				clientX: 0, //The coordinates within the viewport
				clientY: 0,
				ctrlKey: false,
				altKey: false,
				shiftKey: false,
				metaKey: false, //I *think* 'meta' is 'Cmd/Apple' on Mac, and 'Windows key' on Win. Not sure, though!
				button: 0, //0 = left, 1 = middle, 2 = right
				relatedTarget: null
			};

		//Merge the options with the defaults
		for (var key in options) {
			if (options.hasOwnProperty(key)) {
				opts[key] = options[key];
			}
		}

		//Pass in the options
		event.initMouseEvent(
			opts.type,
			opts.canBubble,
			opts.cancelable,
			opts.view,
			opts.detail,
			opts.screenX,
			opts.screenY,
			opts.clientX,
			opts.clientY,
			opts.ctrlKey,
			opts.altKey,
			opts.shiftKey,
			opts.metaKey,
			opts.button,
			opts.relatedTarget
		);

		//Fire the event
		target.dispatchEvent(event);
	}

	function loadMorePageInSearchPage() {
		let openPageNum = 0;
		$('.js-page-load-more').click(function () {
			openPageNum++;

			let nextPage = $('.boost-pfs-search-result-page-pagination .pagination__item--current').closest('li').next().find('.pagination__item.link')[0];
			let pagesHtml = $('.boost-pfs-search-result-pages').html();
			simulatedClick(nextPage);
			$('.js-previous-pages').append(pagesHtml);

			let countPage = $('.boost-pfs-search-result-page-pagination .pagination__item--current').closest('ul').find('.pagination__item.link').not('.pagination__item-arrow').length;
			if (countPage === openPageNum) {
				$(this).css({'display': 'none'});
			}
		});
	}
	jQ('.boost-pfs-search-result-toolbar-wrap').on('click', '.boost-pfs-search-result-panel-item.boost-active', function () {
		let filter = jQ('.boost-pfs-filter-tree.boost-pfs-filter-tree-v');

		if (filter.hasClass('boost-hidden')) {
			jQ('.collection-wrapper .collection-filters').addClass('boost-hidden');
		} else {
			jQ('.collection-wrapper .collection-filters').removeClass('boost-hidden');
		}
	});

	document.addEventListener('DOMContentLoaded', function() {
		localStorage.removeItem('collection&product');
		sessionStorage.removeItem('boostPFSScrollbackPostion');
		
		if ('scrollRestoration' in history) {
		  history.scrollRestoration = 'manual';
		}

		const backScrollTo = localStorage.getItem('backScrollTo');

		setTimeout(() => {
			const productCard = document.querySelector(`[data-product-card][data-id="${backScrollTo}"]`);

			if (productCard) {
				productCard.scrollIntoView({ behavior: 'smooth' });
			}
		}, 2200);
	  });

	// Lazy loading now handled by native browser loading="lazy" attribute
	// Keeping the legacy code commented for reference
	/*
	function initLazyLoad() {
		if ('IntersectionObserver' in window) {
			const imageObserver = new IntersectionObserver((entries, observer) => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						const img = entry.target;
						const picture = img.closest('picture');
						
						// Update image src
						if (img.dataset.src) {
							img.src = img.dataset.src;
							img.removeAttribute('data-src');
						}
						if (img.dataset.srcset) {
							img.srcset = img.dataset.srcset;
							img.removeAttribute('data-srcset');
						}
						
						// Update source elements
						if (picture) {
							picture.querySelectorAll('source').forEach(source => {
								if (source.dataset.srcset) {
									source.srcset = source.dataset.srcset;
									source.removeAttribute('data-srcset');
								}
							});
						}
						
						img.classList.remove('lazyload');
						img.classList.add('lazyloaded');
						observer.unobserve(img);
					}
				});
			}, {
				rootMargin: '50px 0px',
				threshold: 0.01
			});
			
			// Return observer for reuse
			return imageObserver;
		}
		return null;
	}
	
	let globalImageObserver = initLazyLoad();
	*/
})();
